import { api } from '../service/NetworkUtility';
import { format } from 'date-fns';
import { logError } from './ErrorService';

let controller = new AbortController();

// Allow piecemeal updates to parameters
export const RequestParameters = (current, updated) => {
    if (current === null || typeof current === 'undefined') {
        current = {};
    }

    if (updated === null || typeof updated === 'undefined') {
        updated = {};
    }

    return {
        ...current,
        ...updated
    };
};

const maybe = (value) => {
    return value ? value : null;
};

const lintRequest = (request) => {
    return {
        workflowTypeCode: request.workflow,

        // Service expect yyyy-MM-dd format. It will default to one-year if not provided.
        startOn: request.startDate ? format(request.startDate, 'yyyy-MM-dd') : null,
        endOn: request.endDate ? format(request.endDate, 'yyyy-MM-dd') : null,

        maxResults: maybe(request.maxResults),
        sortColumn: maybe(request.sortColumn),
        sortDirection: maybe(request.sortDirection),
        disbursementUUID: maybe(request.disbursementUuid),
        disbursementAmountMin: maybe(parseFloat(request.disbursementAmountMin)),
        disbursementAmountMax: maybe(parseFloat(request.disbursementAmountMax)),
        claimantName: maybe(request.partyName),
        paymentMethods: maybe(request.paymentMethods),
        paymentNumber: maybe(request.paymentNumber),
        paymentType: maybe(request.paymentType),
        paymentTypes: maybe(request.paymentTypes),
        statusCodes: maybe(request.statusCodes),
        vendorCode: maybe(request.vendorCode)
    };
};

export const makeRequest = (request, companyNumber, successHandler, errorHandler, exportOptions) => {
    const lintedRequest = lintRequest(request);
    if (exportOptions) {
        exportOptions(lintedRequest);
    }

    const url = `/companies/${companyNumber}/payments/search`;

    controller.abort();
    controller = new AbortController();

    // Uncomment the Wrapped promise delay to test
    //new Promise(resolve => setTimeout(resolve, 2000)).then(() => {
    api.post(url, lintedRequest, {
        signal: controller.signal
    })
        .then(transformResponse)
        .then((data) => {
            successHandler(data, lintedRequest, request);
        })
        .catch((error) => {
            // Abort errors can be ignored
            if (error?.code !== 'ERR_CANCELED') {
                //navigate hook does not work here, using window.location to redirect
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    //unauthorized user - log unauth attempt and redirect
                    logError("Unauthorized user attempt", () => {
                        window.location = "/unauthorizedUser?ps";
                    });
                } else {
                    errorHandler(error);
                }
            }
        });
    //});
}

export function cancelRequest() {
    controller.abort();
}

const transformResponse = (response) => {
    return response.data;
}